export default __webpack_public_path__ + "static/media/test.d688d685.pdf";